module.exports = __webpack_public_path__ + "static/media/Mask_Group.39d85af0.png";